module.exports = __webpack_public_path__ + "assets/warning.22332f3d7042c039c4ea239da036e8c4.svg";


//////////////////
// WEBPACK FOOTER
// ./img/warning.svg
// module id = 648
// module chunks = 0